module.exports = __webpack_public_path__ + "static/media/step_1_risk.66af3cab.svg";